/* eslint-disable import/no-unresolved */
import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

const Container = (props) => (
  <div className={`container ${props.className}`}>
    {props.children}
  </div>
);
Container.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
};
Container.defaultProps = {
  className: '',
  children: null,
};

export default Container;
